module.exports = __webpack_public_path__ + "img/img02.be180cbb.svg";